import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSuperAuth } from '../contexts/SuperAuthContext';

export default function SuperProtectedRoute({ children }) {
  const { user, ready } = useSuperAuth();
  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400 text-sm">
        Cargando…
      </div>
    );
  }
  if (!user) return <Navigate to="/super/login" replace />;
  return children;
}
